import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import DeleteIcon from '@material-ui/icons/Delete'
import { useKeycloak } from '@react-keycloak/web'

import searchContext from '../../../../PropertySearch/FiltersComponent/context/context'
import listContext from '../../../../Common/context/context'
import { deleteSavedSearch } from '../../../../PropertySearch/Services/propertySearchService'
import { getUserSFId, getPollingAlertDuration, getErrorAlertDuration } from '../../../../PropertySearch/Utility/Utility'
import { pollMessageStatus } from '../../../../PropertyList/Utility/GetMessageStatus/GetMessageStatus'
import { readyToUpdate, pendingResponse } from '../../../../PropertyList/Utility/PropertyListUtility'

const DeletePropertyList = props => {
    const { keycloak } = useKeycloak()
    const { propertyDetailList } = props
    let { propertyList } = useContext(listContext)
    const { savedLists, setSavedLists, setShowAlert, setalertProps, setSelectedMenu,
        fetchSavedLists, openModalWindow } = useContext(searchContext)
    const [saveClicked, setSaveClicked] = useState(false)

    useEffect(() => {
        if (saveClicked) {
            handleDelete(propertyDetailList || propertyList)
        }
    }, [saveClicked])


    const getDeletePayload = item => {
        try {
            const user_SFId = getUserSFId()

            const payload = {
                'action': 'delete',
                'data': {
                    'userId': keycloak.subject,
                    // 'lastModifiedById': user_SFId,
                    'omniViewUserId': user_SFId,
                    'isCart': true,
                    // 'dataSource': 'PolarisDelete',
                    'omniViewPropertyListId': item.omniViewPropertyListId,
                    'polarisPropertySearchCriteriaId': item.polarisPropertySearchCriteriaId,
                    // "polarisLastModifiedById": keycloak.subject,
                    // "polarisLastModifiedByUserName": keycloak.tokenParsed.name
                }
            }
            return payload
        }
        catch (e) {
            console.log('Error :: ', e)
        }
    }

    // const removeSearch = item => {
    //     let index = -1

    //     if (item.polarisPropertySearchCriteriaId) {
    //         index = savedLists.findIndex(x => x.polarisPropertySearchCriteriaId == item.polarisPropertySearchCriteriaId)
    //     }
    //     if (index === -1 && item.omniViewPropertyListId) {
    //         index = savedLists.findIndex(x => x.omniViewPropertyListId == item.omniViewPropertyListId)
    //     }

    //     if (index !== -1) {
    //         let newSavedLists = [...savedLists]
    //         newSavedLists.splice(index, 1)
    //         setSavedLists(newSavedLists)
    //     }
    // }

    const onDelete = async (message, type) => {

        try {

            if (type === 'success') {
                await fetchSavedLists()
                if (props.toListPage) {
                    const user_SFId = getUserSFId()
                    setSelectedMenu('savedList')
                    window.history.pushState({}, 'Property Search', '/PropertySearch?view=savedList&userId=' + user_SFId)
                }
            }

            setSaveClicked(false)
            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)
            openModalWindow(false)

        } catch (error) {
            console.log(' error in on-Delete :: ', error)
        }

    }

    const handleDelete = async (item) => {
        try {
            // const payload = getDeletePayload(item)
            // const response = await deleteSavedSearch(payload)

            let response
            if (await readyToUpdate()) {
                const payload = getDeletePayload(item)
                openModalWindow(true)
                props.closeModal()
                response = await deleteSavedSearch(payload)
            } else {
                response = await pendingResponse()
            }

            if (response && response.status === 200) {
                pollMessageStatus(response.data.messageId, onDelete, '', 'List Deleted!! ', 'Something went wrong !!')
            } else {
                const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
                setalertProps({ message: errorMessage, type: 'error' })
                setShowAlert(true)
            }

        } catch (e) {
            console.log('Error in handleDelete::: ', e)
        }
    }

    return (
        <>
            <div data-testid="test-delete-property-popup" className='flex flex-col py-4 gap-4 drawer-w'>
                <div className='flex flex-row border-b-1 border-base px-4 pb-2'>
                    <span className='pb-4'>
                        <DeleteIcon fontSize="small" />
                    </span>
                    <span className='px-3'>
                        Delete: <span className='px-1 font-semibold'>{propertyDetailList ? propertyDetailList.name : propertyList.name}</span>
                    </span>
                </div>
                <div className='py-2 px-4'>
                    <div className='flex justify-end space-x-4 mt-auto'>
                        <div>
                            <button data-testid='test-delete-property-cancel' onClick={props.closeModal} className='btn btn-sm' type='button'>Close</button>
                        </div>
                        <div>
                            {saveClicked ?
                                <button className="btn btn-sm btn-primary c-disabled">
                                    <span className="loader h-5 w-5 mx-2" ></span>
                                    <span className="px-2">Deleting</span>
                                </button>
                                :
                                <button data-testid='test-delete-property-confirm' onClick={() => { setSaveClicked(true) }} className={`btn btn-sm btn-primary`}>Confirm</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DeletePropertyList
